import api from "../../utils/Api";
import {
    LINK_DESTINATION_CODE_REQUEST,
    LINK_DESTINATION_CODE_SUCCESS,
    LINK_DESTINATION_CODE_ERROR,
} from "./LinkDestinationCodeTypes";

export const linkDestinationCodesRequest = () => {
    return {
        type: LINK_DESTINATION_CODE_REQUEST,
    };
};

export const linkDestinationCodesSuccess = (linkDestinationCodes) => {
    return {
        type: LINK_DESTINATION_CODE_SUCCESS,
        payload: linkDestinationCodes,
    };
};

export const linkDestinationCodesFailure = (error) => {
    return {
        type: LINK_DESTINATION_CODE_ERROR,
        payload: error,
    };
};

export const linkDestinationCodes = (contact_id) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    const payload = {
        associated_related_party_id: contact_id
    }

    return async (dispatch) => {
        dispatch(linkDestinationCodesRequest());
        try {
            const response = await api.post("relatedparty/linkdestinationcode", payload, {
                headers: headers,
            });
            const linkDestinationCodesData = response.data.data;
            dispatch(linkDestinationCodesSuccess(linkDestinationCodesData));
        } catch (error) {
            console.log("Redux error - ", error.response.data.message);
            const errorMsg = error.response.data.message;
            dispatch(linkDestinationCodesFailure(errorMsg));
        }
    };
};
